var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 199,
    viewBox: "0 0 199 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.7 41H41V157.7H157.7V41Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3506 114.258H74.7794L71.1455 120.534H64.2079V141.182H57.6007V120.534H48.3506V114.258ZM123.177 120.534L126.811 114.258H111.449C106.659 114.258 103.521 117.231 103.521 121.773V133.666C103.521 138.291 106.659 141.182 111.449 141.182H125.159V134.905H111.449C110.706 134.905 110.128 134.492 110.128 133.666V121.773C110.128 120.947 110.706 120.534 111.449 120.534H123.177ZM91.6279 114.258C96.4181 114.258 99.4739 117.231 99.4739 121.773V141.182H82.4603C77.6701 141.182 74.2013 137.713 74.2013 132.923C74.2013 128.133 77.6701 124.664 82.4603 124.664H92.8667V121.773C92.8667 120.947 92.3712 120.534 91.6279 120.534H75.6054L79.2393 114.258H91.6279ZM92.8667 130.363H83.2862C81.8822 130.363 80.8911 131.354 80.8911 132.758C80.8911 134.162 81.8822 135.153 83.2862 135.153H92.8667V130.363ZM147.789 120.534L151.423 114.258H136.061C131.271 114.258 128.133 117.231 128.133 121.773V133.666C128.133 138.291 131.271 141.182 136.061 141.182H149.771V134.905H136.061C135.318 134.905 134.74 134.492 134.74 133.666V121.773C134.74 120.947 135.318 120.534 136.061 120.534H147.789Z",
    fill: "#1F2223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner6);
export default __webpack_public_path__ + "static/media/partner_6.1b4f845217cf310ac933dbedd277fe58.svg";
export { ForwardRef as ReactComponent };